import Vue from 'vue'
import Router from 'vue-router'

import ShareRouter from '@/components/share/router'
import ComplexRouter from '@/components/complex/router'
import StudentRouter from '@/components/student/router'
import TopicRouter from '@/components/topic/router'
import v3Router from '@/components/v3/router'
import h5appRouter from '@/components/H5APP/router'
import groupActivitiesRouter from '@/components/groupActivities/router'
import aojiEnglish from '@/components/aojiEnglish/router'
import newGroupRouter from '@/components/newGroupActivities/router'
import ForXiaoXiMinApp from '@/components/ForXiaoXiMinApp/router'

import speechEvaluation from '@/components/speechEvaluation/router'
import assessment from "@/components/assessment/router"
import newImg from '@/components/newImg/router'

import config from '../../config/env.js'
import CryptoJS from 'crypto-js'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/share'
    },
    ShareRouter,
    ComplexRouter,
    StudentRouter,
    TopicRouter,
    v3Router,
    h5appRouter,
    groupActivitiesRouter,
    aojiEnglish,
    newGroupRouter,
    ForXiaoXiMinApp,
    speechEvaluation,
    assessment,
    newImg
  ]
})

router.beforeEach((to, from, next) => {
  // 判断是否自动授权
  console.log('config.devState : ', config.devState)
  if (config.devState) {
    // $.getScript('https://res.wx.qq.com/mmbizwap/zh_CN/htmledition/js/vconsole/3.0.0/vconsole.min.js', function () { // 加载test.js,成功后，并执行回调函数
    //   var vConsole = new VConsole()
    //   console.log('init vConsole')
    // })
  }
  if(to.meta.title){
    document.title = to.meta.title
  }
  let timer = setTimeout(() => {
    if(!document.title){
      document.title = '小希'
      clearTimeout(timer)
    }
  }, 3000)
  console.log('to:', to)
  console.log('from:', from)
  console.log('navigator.userAgent is =>', navigator.userAgent)
  try {
    // Encrypt
    console.log('location.protocol', location.protocol)
    console.log('location.host', location.host)

    to.query.authorization && sessionStorage.setItem("authorization", to.query.authorization);

    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify({
      to: to.fullPath,
      title: to.meta.title,
      userAgent: navigator.userAgent
    }), '8T86EOqN7eUUhLVG').toString()
    if (window.location.host.includes('test-h5.xiaoxiedu.com')) {
      console.log('我是测试环境，执行了http://test-h5.xiaoxiedu.com/push/push/')
      new Image().src = 'http://test-h5.xiaoxiedu.com/push/push/' + window.btoa(ciphertext)
    } else if (window.location.host.includes('uat-h5.xiaoxiedu.com')) {
      console.log('我是预发布环境，执行了http://uat-h5.xiaoxiedu.com/push/push/')
      new Image().src = 'http://uat-h5.xiaoxiedu.com/push/push/' + window.btoa(ciphertext)
    } else if (window.location.host.includes('h5.xiaoxiedu.com')) {
      console.log('我是正式环境，没操作')
    }
  } catch (error) {

  }
  if (navigator.userAgent.indexOf('smart-counselor') !== -1) {
    console.log('is smart-counselor app')
    let appInfo = {}
    try {
      appInfo = JSON.parse(navigator.userAgent.toString())
    } catch (error) {
      console.log('navigator.userAgent to json error >', error)
      appInfo = {}
    }

    localStorage.setItem('token', JSON.stringify({
      platform: appInfo.platform,
      memberId: appInfo.memberId || '',
      token: appInfo.token || '',
      isSmartApp: true
    }))
    console.log('token save success')
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js